<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
    <span>位置：</span>
    <ul class="placeul">
    <li><a href="#">首页</a></li>
    <li>通讯录</li>
    <li><a href="#">通讯录</a></li>
    </ul>
    </div>
    
    <div class="rightinfo">
    
    
    <ul class="seachform mt20">
    
        <li><label>姓名</label><input name="" v-model="name" type="text" class="scinput" /></li>
        
        <li><label>电话</label><input name="" v-model="mphone1" type="text" class="scinput" /></li>
        
        <li><label>传真</label><input name="" v-model="fax1" type="text" class="scinput" /></li>
        
        <li><label>单位</label><input name="" v-model="company" type="text" class="scinput" /></li>
        
        <li><label>&nbsp;</label><input name="" type="button" class="scbtn" @click="pageChange(1)" value="查询"/></li>
    
    </ul>
    
    <div class="tools">
    	<ul class="toolbars">
        <li :class="{click:isClickList[0].isClick}" @click="selecttxlcont(0,'')">全部</li>
        <li v-for="item,index in txlGroupList" @click="selecttxlcont(index+1, item.groupid)" :class="{click:isClickList[index+1].isClick}">{{item.groupname}}</li>
        
        </ul>       
        
    
    </div>
    
    <ul class="addresssearch ">
        <li>查看:</li>
        <li><a href="#" :class="{click:isRedList[0].isClick}" @click="selectszm('',0)">全部</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[1].isClick}" @click="selectszm('a',1)">A</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[2].isClick}" @click="selectszm('b',2)">B</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[3].isClick}" @click="selectszm('c',3)">C</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[4].isClick}" @click="selectszm('d',4)">D</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[5].isClick}" @click="selectszm('e',5)">E</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[6].isClick}" @click="selectszm('f',6)">F</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[7].isClick}" @click="selectszm('g',7)">G</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[8].isClick}" @click="selectszm('h',8)">H</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[9].isClick}" @click="selectszm('i',9)">I</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[10].isClick}" @click="selectszm('j',10)">J</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[11].isClick}" @click="selectszm('k',11)">K</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[12].isClick}" @click="selectszm('l',12)">L</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[13].isClick}" @click="selectszm('m',13)">M</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[14].isClick}" @click="selectszm('n',14)">N</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[15].isClick}" @click="selectszm('o',15)">O</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[16].isClick}" @click="selectszm('p',16)">P</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[17].isClick}" @click="selectszm('q',17)">Q</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[18].isClick}" @click="selectszm('r',18)">R</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[19].isClick}" @click="selectszm('s',19)">S</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[20].isClick}" @click="selectszm('t',20)">T</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[21].isClick}" @click="selectszm('u',21)">U</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[22].isClick}" @click="selectszm('v',22)">V</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[23].isClick}" @click="selectszm('w',23)">W</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[24].isClick}" @click="selectszm('x',24)">X</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[25].isClick}" @click="selectszm('y',25)">Y</a></li>
        <li>-</li>
        <li><a href="#" :class="{click:isRedList[26].isClick}" @click="selectszm('z',26)">Z</a></li>
    </ul>
    <table class="tablelist">
    	<thead>
    	<tr>
        <th><input name="allCheck" type="checkbox" value="" id="allCheck" @click="changAllCheck()"/> </th>
        <th>姓名</th>
        <th>E-mail</th>
        <th>手机</th>
        <th>传真</th>
        <th>单位</th>
        <th>分组</th>
        <th>操作</th>
        </tr>
        </thead>
        <tbody>
            <tr v-for="item in txlContList">
                <td><input name="selCheck" id="selCheck"  type="checkbox" :value="item.contid" /></td>
                <td>{{item.name}}</td>
                <td>{{item.email1}}</td>
                <td>{{item.mphone1}}</td>
                <td>{{item.fax1}}</td>
                <td>{{item.company}}</td>
                <td><span v-for="gitem in txlGroupList" v-if="gitem.groupid==item.groupid">{{gitem.groupname}}</span></td>
                <td>
                    <a href="#" @click="edittxlcont(item.contid)" class="tablelink">编辑</a>
                    <a href="#" class="tablelink" @click="callphone(item.mphone1)"> 电话</a>
                    <a href="#" class="tablelink" @click="sendsms(item.mphone1)">短信</a>
                    <!-- <a href="#" class="tablelink" @click="voicesms(item.mphone1)">语音短信</a> -->
                </td>
            </tr>
        </tbody>
    </table>
    
   
    <div class="pagin">
    	<el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[50]"
            :page-size="50"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount">
        </el-pagination>
    </div>
    <div class="tools">
        <el-button type="primary" @click="plDelTxlCont()" ><span class="f14">批量删除</span></el-button> 
        <el-button type="primary" @click="plUpload()" ><span class="f14">批量导入</span></el-button> 
    </div>
    
    <div class="tip">
    	<div class="tiptop"><span>提示信息</span><a></a></div>
        
      <div class="tipinfo">
        <span><img src="images/ticon.png" /></span>
        <div class="tipright">
        <p>是否确认对信息的修改 ？</p>
        <cite>如果是请点击确定按钮 ，否则请点取消。</cite>
        </div>
        </div>
        
        <div class="tipbtn">
        <input name="" type="button"  class="sure" value="确定" />&nbsp;
        <input name="" type="button"  class="cancel" value="取消" />
        </div>
    
    </div>
    
    <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
        top: 0; left: 0;display: block;" v-show="loadingShow"></div>
    <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
        -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
        <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
        <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
    </div>
    
    
    </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            isClickList:[
                {isClick:true},
            ],
            isRedList:[
                {isClick:true},{isClick:false},{isClick:false},{isClick:false},{isClick:false},{isClick:false},{isClick:false},{isClick:false},{isClick:false},
                {isClick:false},{isClick:false},{isClick:false},{isClick:false},{isClick:false},{isClick:false},{isClick:false},{isClick:false},{isClick:false},
                {isClick:false},{isClick:false},{isClick:false},{isClick:false},{isClick:false},{isClick:false},{isClick:false},{isClick:false},{isClick:false},
            ],
            txlContList:[],
            txlGroupList:[],
            pageIndex:0,
            totalCount:0,
            name:'',
            mphone1:'',
            fax1:'',
            company:'',
            groupid:'',
            szm:'',
            loadingShow: true,
        }
    },
    mounted(){        
        this.pageChange(1);
    },
    methods:{
        handleSizeChange(val) {
            this.pageChange(val)
        },
        handleCurrentChange(val) {
            this.pageChange(val)
        },
        selectszm(szm, index){
            this.loadingShow = true;
            this.szm = szm;
            this.isRedList.forEach(function(obj){
                obj.isClick = false;
            });
            this.isRedList[index].isClick = true;
            this.pageChange(1);
        },
        pageChange(pageIndex){
            this.cancelChecke();
            var that = this
            let data = {'pageIndex':pageIndex,'pageSize':50, 'account':'','groupid':this.groupid,'name':this.name,'mphone1':this.mphone1,'phone1':'','pinyin':'','fax1':this.fax1,'company':this.company,'szm':this.szm}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/txl/txlcontlist.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.txlContList = res.data.txlContList
                    that.txlGroupList = res.data.txlGroupList
                    //console.log("txlGroupList.length=" + res.data.txlGroupList.length)
                    for(let i = 0; i < res.data.txlGroupList.length; i++)
                    {
                        that.isClickList.push({isClick:false})
                    }
                    //console.log(JSON.stringify(that.isClickList));
                    that.pageIndex = parseInt(pageIndex);
                    that.pageCount = res.data.page.pageCount;
                    that.totalCount = res.data.page.totalCount;
                    that.currentPage = pageIndex;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        selecttxlcont(index, groupid){
            // console.log(JSON.stringify(this.isClickList));
            this.isClickList.forEach(function(obj){
                obj.isClick = false;
            });
            this.isClickList[index].isClick = true;

            this.groupid = groupid
            this.pageChange(1)
        },
        edittxlcont(contid){
            location.href = "/txledit?contid=" + contid;
        },
        changAllCheck(){
            var checkers = document.getElementsByName('selCheck');
            if (document.getElementById("allCheck").checked == true)
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = true;
                }
            }
            else
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = false;
                }
            }
        },
        cancelChecke(){
            if(document.getElementById("allCheck").checked == true)
                document.getElementById("allCheck").checked = false;

            var checkers = document.getElementsByName('selCheck');
            for ( var i = 0; i < checkers.length; i++){
                if(checkers[i].checked){
                    checkers[i].checked = false;
                }
            }
        },
        plUpload(){
            location.href = "/txlupload";
        },
        plDelTxlCont(){
            var ids = '';
            var checkers = document.getElementsByName('selCheck');
            for ( var i = 0; i < checkers.length; i++){
                if(checkers[i].checked){
                    if(ids =='')
                        ids = checkers[i].value;
                    else
                        ids = ids + ',' + checkers[i].value;
                }
            }
            if(ids == ''){
                alert("请选择要删除的项！");
                return;
            }
            let that = this;
            let data = {'contids':ids,'groupid':''};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/txl/deletetxlcont.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("删除信息成功！");
                    that.pageChange(1);
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        callphone(mobile) {
            this.$router.push({
                path: '/dialsend',
                query: {
                    mobile: mobile,
                },
            })
        },
        sendsms(mobile) {
            this.$router.push({
                path: '/smssend',
                query: {
                    mobile: mobile,
                },
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/txl/txlcont.vue